import { Close, Delete, Save } from '@mui/icons-material';
import { Button, IconButton, Modal } from '@mui/material';
import { Row } from 'antd';
import { DeleteModal } from 'components/Dialog';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ImageAndAssignmentModal from './ImageAndAssignementModal';
import { captureException } from '@sentry/react';
import SentryWrap from 'components/Sentry';

const EngageModal = ({
  page,
  open,
  pageId,
  bookId,
  onRemove = () => {},
  data,
  onChangeImage = () => {},
  onChangeAssignment = () => {},
  title = 'Engage Units',
  updateState = () => {},
  filteredQuizAndActivityEngagement = [],
  onClose = () => {},
  pageIswhere = { units: false, subUnits: false, subLesson: false },
  showOptions,
  setShowOptions,
}) => {
  const showAlert = useAlert();
  const [deleteModal, setDeleteModal] = useState(false);
  const [imageData, setImageData] = useState([]);
  const [engagePageDrawer, setEngagePageDrawer] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setEngagePageDrawer(open);
  }, [open]);

  useEffect(() => {
    if (data && engagePageDrawer) {
      if (data?.imageData && Array.isArray(data?.imageData)) {
        setImageData([...data?.imageData] || []);
      } else {
        setImageData([...data?.imageData]);
      }
    } else {
      setImageData([]);
      setDeleteModal(false);
    }
  }, [data, engagePageDrawer]);

  const handleClose = () => {
    setEngagePageDrawer(false);
    setImageData([]);
    setDeleteModal(false);
    onClose();
  };

  const handlerOnChange = (data) => {
    onChangeImage(data);
    //handleClose();
  };

  const handleAssignment = (data, index) => {
    onChangeAssignment(data, index);
  };

  const saveHandler = (data) => {
    try{
      if (loader) return;
      setLoader(true);
      const updatedImageData = data ? data : imageData;
      const checkSomeData = updatedImageData.some((item) => item.resource === '');
      const isUploading = Object.values(loadingStates).some((status) => status === true);
  
      if (isUploading) {
        showAlert('Please wait until all uploads are complete', 'warning');
        return;
      } else if (checkSomeData) {
        showAlert('Empty Image cannot be saved');
        return;
      }
      handlerOnChange({ pageId: pageId, imageData: updatedImageData, showOptions: showOptions });
      setLoader(false);
    }catch(error){
      console.log(error);
      captureException(error?.message || 'EngageModal: Error in saveHandler');
    }finally{
      setLoader(false);
    }
  };

  return (
    <SentryWrap>
      <DeleteModal
        deleteToggle={deleteModal}
        onDelete={() => {
          onRemove(data);
          handleClose();
        }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove "${title}" on pageId ${pageId}?`}
      />

      <Modal
        open={engagePageDrawer}
        onClose={() => handleClose()}
        style={{ height: '100%', width: '100%' }}
        disableEscapeKeyDown
        disableBackdropClick
        disableScrollLock
        className="engage-modal"
      >
        <ModalContent style={{ width: '70%', height: '90%' }}>
          <Row style={{ justifyContent: 'space-between' }}>
            <TitleText>{title}</TitleText>

            <div
              style={{ right: 10, top: 10 }}
              className="flex w-full justify-end gap-10px absolute "
            >
              {data ? (
                <Delete
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                  color="secondary"
                  style={{ cursor: 'pointer',color:'red' }}
                />
              ) : null}
              <IconButton onClick={() => handleClose()} style={{ padding: 0, marginRight: 10,cursor:'pointer' }}>
                <Close color="secondary" />
              </IconButton>
            </div>
          </Row>
          <ModalConfigArea>
            <ImageAndAssignmentModal
              onChange={handlerOnChange}
              pageId={pageId}
              onChangeDescription={() => {}}
              hasDescription={false}
              imageData={imageData}
              setImageData={setImageData}
              selectedType={'uploader'}
              isAssignment={true}
              handleAssignment={handleAssignment}
              from={'admin_engage'}
              loadingStates={loadingStates}
              setLoadingStates={setLoadingStates}
              bookId={bookId}
              filteredQuizAndActivityEngagement={filteredQuizAndActivityEngagement}
              page={page}
              saveHandler={saveHandler}
              showOptions={showOptions}
              setShowOptions={setShowOptions}
              pageIswhere={pageIswhere}
            />
          </ModalConfigArea>
        </ModalContent>
      </Modal>
    </SentryWrap>
  );
};

export default EngageModal;

const ModalContent = styled.div`
  left: 50%;
  max-width: 100vw;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  transform: translate(-50%, -50%);
  top: 50%;
  @media (max-width: 1366px) {
    width: 90vw;
  }

  @media (max-width: 500px) {
    max-height: 560px;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
`;

const Input = styled.input`
  background-color: transparent;
  border: 1px dashed gray;
  border-radius: 3px;
  box-shadow: none;
  font-size: inherit;
  font-weight: 400;
  outline: none;
  padding: 4px 8px;
  transition: all 300ms ease;
  width: 250px;
  margin-left: 8px;
`;
